import React from "react";

import "./styles.css";
import Intro from "./pages/Intro.js";
import Footer from "./pages/Footer.js";

const App = () => {
  return (
    
    <>
    <Intro/>
    <Footer/>
    </>
  );
};

export default App;
